(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anime-image-banner"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init(root) {
    if (root.dataset.bannerReady) return;
    root.dataset.bannerReady = 'true';

    var slides = root.querySelectorAll('[data-abnr-slide]');
    var dots = root.querySelectorAll('[data-abnr-dot]');
    var prev = root.querySelector('[data-abnr-prev]');
    var next = root.querySelector('[data-abnr-next]');
    if (!slides.length) return;

    var index = 0;
    var auto = root.dataset.autoAdvance === 'true';
    var interval = (parseInt(root.dataset.interval, 10) || 6) * 1000;
    var timer = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var suppressClick = false;

    function go(n) {
      index = ((n % slides.length) + slides.length) % slides.length;
      slides.forEach(function(s, i) { s.classList.toggle('is-active', i === index); });
      dots.forEach(function(d, i) { d.classList.toggle('is-active', i === index); });
      restart();
    }

    function restart() {
      if (timer) { clearInterval(timer); timer = null; }
      if (auto && slides.length > 1 && !reduced && !document.hidden) {
        timer = setInterval(function() { go(index + 1); }, interval);
      }
    }

    function pause() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function(d, i) { d.addEventListener('click', function(e) { e.stopPropagation(); go(i); }); });
    if (prev) prev.addEventListener('click', function(e) { e.stopPropagation(); go(index - 1); });
    if (next) next.addEventListener('click', function(e) { e.stopPropagation(); go(index + 1); });

    slides.forEach(function(slide) {
      var url = slide.dataset.slideUrl;
      if (!url) return;
      slide.addEventListener('click', function(e) {
        if (suppressClick) return;
        if (e.target.closest('a, button, input, select, textarea')) return;
        window.location.href = url;
      });
    });

    if (slides.length > 1) {
      var swipeArea = root.querySelector('.abnr-slideshow__viewport') || root;
      var startX = null, startY = null, dx = 0, isSwipe = false;

      swipeArea.addEventListener('touchstart', function(e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        dx = 0;
        isSwipe = false;
        pause();
      }, { passive: true });

      swipeArea.addEventListener('touchmove', function(e) {
        if (startX === null) return;
        dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        if (!isSwipe && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) isSwipe = true;
      }, { passive: true });

      swipeArea.addEventListener('touchend', function() {
        if (startX === null) return;
        startX = null;
        if (isSwipe && Math.abs(dx) > 40) {
          go(dx < 0 ? index + 1 : index - 1);
          suppressClick = true;
          setTimeout(function() { suppressClick = false; }, 400);
        } else {
          restart();
        }
      }, { passive: true });

      swipeArea.addEventListener('touchcancel', function() {
        startX = null;
        restart();
      }, { passive: true });
    }

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', restart);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', restart);
    document.addEventListener('visibilitychange', function() {
      document.hidden ? pause() : restart();
    });

    root.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
    });

    go(0);
  }

  function initAll() {
    document.querySelectorAll('[data-abnr-slideshow]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
